export { default } from "src/templates/404/PageComponent";
